import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import AutoLabelViewState from './AutoLabelViewState';

interface CLPViewState {
    justificationSent: boolean;
    selectedCLPLabel: CLPLabel;
    originalCLPLabel?: CLPLabel;
    nonTenantLabelString?: string;
    labelApplyMethod: LabelApplyMethod;
    autoLabelViewState: AutoLabelViewState;
}

export enum LabelApplyMethod {
    Manual = 'manual',
    Automatic = 'automatic',
    Default = 'default',
}

export default CLPViewState;
